import { render } from "./LeadgenFormView.vue?vue&type=template&id=22c2c77a"
import script from "./LeadgenFormView.vue?vue&type=script&lang=js"
export * from "./LeadgenFormView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/LeadgenFormView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22c2c77a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22c2c77a', __exports__)) {
    api.reload('22c2c77a', __exports__)
  }
  
  module.hot.accept("./LeadgenFormView.vue?vue&type=template&id=22c2c77a", () => {
    api.rerender('22c2c77a', render)
  })

}


export default __exports__